import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const regions = [
  { name: 'United Kingdom', city: 'London',      code: 'eu-west-2',      href: '/data-sovereignty/europe' },
  { name: 'Ireland',        city: 'Dublin',       code: 'eu-west-1',      href: '/data-sovereignty/europe' },
  { name: 'Germany',        city: 'Frankfurt',    code: 'eu-central-1',   href: '/data-sovereignty/europe' },
  { name: 'USA',            city: 'N. Virginia',  code: 'us-east-1',      href: '/data-sovereignty/usa'    },
  { name: 'Canada',         city: 'Toronto',      code: 'ca-central-1',   href: '/data-sovereignty/canada' },
  { name: 'UAE',            city: 'Dubai',        code: 'me-central-1',   href: '/data-sovereignty/uae'    },
  { name: 'South Africa',   city: 'Cape Town',    code: 'af-south-1',     href: '/data-sovereignty/africa' },
  { name: 'Australia',      city: 'Sydney',       code: 'ap-southeast-2', href: '/data-sovereignty'        },
  { name: 'Singapore',      city: 'Singapore',    code: 'ap-southeast-1', href: '/data-sovereignty/singapore' },
];

const stats = [
  { value: '9',       label: 'SAP B1-ready regions'  },
  { value: '5',       label: 'Continents covered'     },
  { value: '99.995%', label: 'Uptime SLA'             },
];

const AWSMap = () => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Stats strip */}
      <div className="flex flex-wrap justify-center gap-8 md:gap-16 mb-12">
        {stats.map(({ value, label }) => (
          <div key={label} className="text-center">
            <div className="text-4xl md:text-5xl font-bold text-white mb-1">{value}</div>
            <div className="text-slate-400 text-xs uppercase tracking-widest font-semibold">{label}</div>
          </div>
        ))}
      </div>

      {/* Region cards — centred content, clickable, link to data sovereignty */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4">
        {regions.map((r, idx) => (
          <button
            key={r.code}
            onClick={() => navigate(r.href)}
            className="relative text-center bg-slate-800/60 backdrop-blur-sm border border-cyan-500/20 rounded-2xl p-5 md:p-6 hover:bg-slate-700/70 hover:border-cyan-400/60 hover:scale-[1.02] transition-all duration-200 group overflow-hidden cursor-pointer"
            data-testid={`region-card-${r.code}`}
          >
            {/* Subtle glow on hover */}
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/0 to-blue-500/0 group-hover:from-cyan-500/8 group-hover:to-blue-500/8 transition-all duration-300 rounded-2xl pointer-events-none" />

            <div className="relative z-10 flex flex-col items-center">
              {/* Pulsing live indicator */}
              <div className="flex items-center gap-1.5 mb-3">
                <div
                  className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse"
                  style={{ animationDelay: `${idx * 0.25}s` }}
                />
                <span className="text-[9px] text-cyan-400/70 font-semibold uppercase tracking-widest">Live</span>
              </div>

              {/* Region name */}
              <div className="font-bold text-white text-lg md:text-xl leading-tight mb-1">
                {r.name}
              </div>

              {/* City */}
              <div className="text-slate-300 text-xs md:text-sm mb-3 leading-tight">
                {r.city}
              </div>

              {/* AWS region code */}
              <div className="font-mono text-[10px] text-cyan-400/60 tracking-wide mb-3">
                {r.code}
              </div>

              {/* Data sovereignty link hint */}
              <div className="flex items-center gap-1 text-[10px] text-slate-500 group-hover:text-cyan-400 transition-colors duration-200">
                <span>Data sovereignty</span>
                <ArrowRight className="w-2.5 h-2.5 group-hover:translate-x-0.5 transition-transform" />
              </div>
            </div>
          </button>
        ))}
      </div>

      {/* Footer */}
      <p className="text-center text-slate-500 text-xs mt-6 tracking-wide">
        All regions SAP Business One-ready · Full data sovereignty options in every region
      </p>
    </div>
  );
};

export default AWSMap;
